<table data-test="GEdJYMQN" class="items-table text-right items-table_light">
  <thead data-test="tELwRCkb">
    <tr data-test="Mn8OisXV" class="items-table__header">
      <th data-test="E3niqpfl" class="text-left pl-5">
        <span
          data-test="bKjnCAi1"
          class="items-table__sort ml-xl-3"
          [class.items-table__sort_active-down]="
            sorter.type === sorterTypes.Name && sorter.order === 'asc'
          "
          [class.active]="sorter.type === sorterTypes.Name && sorter.order === 'desc'"
          (click)="sortBy(sorterTypes.Name)"
        >
          Projects
        </span>
      </th>
      <th data-test="jSqd_5iy">
        <span
          data-test="ErrnT2Dd"
          class="items-table__sort"
          [class.items-table__sort_active-down]="
            sorter.type === sorterTypes.Budget && sorter.order === 'asc'
          "
          [class.active]="sorter.type === sorterTypes.Budget && sorter.order === 'desc'"
          (click)="sortBy(sorterTypes.Budget)"
        >
          Budget
        </span>
      </th>
      <th data-test="YHyxwwWU" class="text-nowrap">
        <span
          data-test="hA75nY1p"
          class="items-table__sort"
          [class.items-table__sort_active-down]="
            sorter.type === sorterTypes.GrossMargin && sorter.order === 'asc'
          "
          [class.active]="
            sorter.type === sorterTypes.GrossMargin && sorter.order === 'desc'
          "
          (click)="sortBy(sorterTypes.GrossMargin)"
        >
          Gross Margin
        </span>
        <button
          data-test="IiOLQOuz"
          class="badge badge_fill-gray badge_offset-right badge_sm"
          mdTooltip
          title="&lt;b&gt;Gross Margin&lt;/b&gt; is the cost of sales or &lt;br&gt; expenses (costs) minus the budget"
        >
          <svg
            data-test="-CI6vwkM"
            class="icon__icon-info"
            width="4.64px"
            height="10.51px"
          >
            <use xlink:href="#icon-info"></use>
          </svg>
        </button>
      </th>
      <th data-test="J4Pjy6yw"></th>
      <th data-test="G77uHBOw" class="text-nowrap">
        <span
          data-test="6Klv0UWX"
          class="items-table__sort"
          [class.items-table__sort_active-down]="
            sorter.type === sorterTypes.Costs && sorter.order === 'asc'
          "
          [class.active]="sorter.type === sorterTypes.Costs && sorter.order === 'desc'"
          (click)="sortBy(sorterTypes.Costs)"
        >
          Costs
        </span>
        <button
          data-test="0rqxnZ5_"
          class="badge badge_fill-gray badge_offset-right badge_sm"
          mdTooltip
          title="&lt;b&gt;Costs&lt;/b&gt; are the cost of sales or expenses"
        >
          <svg
            data-test="L1z5HPhD"
            class="icon__icon-info"
            width="4.64px"
            height="10.51px"
          >
            <use xlink:href="#icon-info"></use>
          </svg>
        </button>
      </th>
      <th data-test="Lwt7tDNd" style="width: 165px">
        <span
          data-test="kbuFI2k3"
          class="items-table__sort"
          [class.items-table__sort_active-down]="
            sorter.type === sorterTypes.InvoicedAmount && sorter.order === 'asc'
          "
          [class.active]="
            sorter.type === sorterTypes.InvoicedAmount && sorter.order === 'desc'
          "
          (click)="sortBy(sorterTypes.InvoicedAmount)"
        >
          Invoiced Amount
        </span>
      </th>
      <th data-test="I6S_fv42" class="items-table__more"></th>
    </tr>
  </thead>
  <tbody data-test="Y80CJ2s5">
    <ng-container *ngFor="let group of groups">
      <tr
        data-test="IWtY79WA"
        class="sublevel-1 row-bg parent row-type row-type_green"
        [class.active]="expandedGroups[group.uuid?.toString() || '']"
        (click)="toggleExpandGroup(group.uuid?.toString() || '')"
      >
        <td data-test="bfXC8P14" class="text-left">
          <div data-test="1qwty-1C" class="d-flex">
            <button data-test="kTqMAvhx" class="items-table__toggle items-table__icon">
              <span
                data-test="0PUcssyk"
                class="items-table__toggle-icon items-table__toggle-icon_close"
              >
                <svg
                  data-test="Oq4jACmp"
                  class="icon__icon-folder"
                  width="13px"
                  height="11px"
                >
                  <use xlink:href="#icon-folder"></use>
                </svg>
              </span>
              <span
                data-test="pa_RnP7m"
                class="items-table__toggle-icon items-table__toggle-icon_open"
              >
                <svg
                  data-test="8LX5JQ_Q"
                  class="icon__icon-folder-open"
                  width="15px"
                  height="11px"
                >
                  <use xlink:href="#icon-folder-open"></use>
                </svg>
              </span>
            </button>
            <div data-test="gbmK5DY4" class="items-table__img-block d-flex">
              <md-letter-image
                data-test="gCskeHL1"
                class="img-square"
                [name]="group.name"
              ></md-letter-image>
              <div data-test="Q0Cr1Zkh" class="items-table__img-block-title">
                <b data-test="lScqTCAo">{{ group.name }}</b>
              </div>
            </div>
          </div>
        </td>
        <td data-test="G12HJQeT" colspan="6"></td>
      </tr>
      <tr
        data-test="83A_XPVM"
        class="sublevel-1 row-bg row-type"
        [class.row-type_green]="project.status === ProjectStatuses.ACTIVE"
        [class.row-type_orange]="project.status === ProjectStatuses.ARCHIVED"
        [style.display]="!expandedGroups[group.uuid?.toString() || ''] ? 'none' : null"
        [routerLink]="['/company-management/projects/details', project.uuid]"
        *ngFor="let project of group.projects"
      >
        <td data-test="3BYR_b8C" class="text-left">
          <div data-test="Oe0N4G5g" class="d-flex">
            <span data-test="xLwsfszw" class="items-table__icon">
              <svg
                data-test="SsuMI7Ud"
                class="icon__icon-path"
                width="8.75px"
                height="11.04px"
              >
                <use xlink:href="#icon-path"></use>
              </svg>
            </span>
            <div data-test="dr_S2kBO" class="items-table__img-block d-flex">
              <md-letter-image
                data-test="bdHgxupC"
                class="img-square"
                [image]="project.resolvedLogo"
                [name]="project.name"
              ></md-letter-image>
              <div data-test="3J8Bs4Ji" class="items-table__img-block-title">
                <b data-test="kS3n6CRm">{{ project.name }}</b>
                <span
                  data-test="tm9Lzd3m"
                  *ngIf="project.number"
                  class="label label_sm label_green"
                >
                  {{ project.number }}
                </span>
              </div>
            </div>
          </div>
        </td>
        <td data-test="YLsNVWos">
          <b data-test="1RlVaXCq" class="text-nowrap font-weight-bold">
            <span data-test="i_2Q9JMp" class="text-light" mdCurrency></span>
            {{ getBudget(project) | fromCents | companyCurrency }}
          </b>
        </td>
        <td data-test="TwnRr1Do">
          <b data-test="17z4W1Sk" class="text-nowrap font-weight-bold">
            <span data-test="U-Tg5tvE" class="text-light" mdCurrency></span>
            {{ project.grossMargin | fromCents | companyCurrency }}
          </b>
          <b data-test="1yQAJ1b3" class="text-nowrap text-light">
            ({{ project.grossMargin | toPercents: project.currentTotalBudget }}%)
          </b>
        </td>
        <td data-test="uIUyXd4H">
          <div
            data-test="ywpjwpYc"
            class="items-table__progressbar progressbar progressbar_green progressbar_sm"
          >
            <div data-test="xNIYvr9o" class="progressbar__bar">
              <div
                data-test="oGNOcjhH"
                class="progressbar__progress"
                style="width: 80%"
              ></div>
            </div>
          </div>
        </td>
        <td data-test="ihVha_YG">
          <b data-test="HCVTfocE" class="text-nowrap font-weight-bold">
            <span data-test="zA9zMc4K" class="text-light" mdCurrency></span>
            20 000.00
          </b>
        </td>
        <td data-test="zIdLFbcr">
          <b data-test="42ZiEuZP" class="text-nowrap font-weight-bold">
            <span data-test="0aX48saN" class="text-light" mdCurrency></span>
            75 000.00
          </b>
        </td>
        <td data-test="rZrAeZ75" class="items-table__more">
          <!--<div class="dropdown-hover">
          <button class="items-table__icon">
            <svg class="icon__icon-more" width="3px" height="13px">
              <use xlink:href="#icon-more"></use>
            </svg>

          </button>
          <div class="dropdown items-table__dropdown dropdown_bottom-right dropdown_arrow" id="">
            <div class="dropdown__wrap">
              <ul class="dropdown__menu">
                <li class="dropdown__menu-item"
                    *ngIf="project.status === ProjectStatuses.ARCHIVED">
                  <a class="dropdown__menu-link" (click)="restore(project.id)">
                    <div class="icon">
                      <svg class="icon__icon-restore" width="14px" height="14px">
                        <use xlink:href="#icon-restore"></use>
                      </svg>

                    </div>Restore</a>
                </li>
                <li class="dropdown__menu-item"
                    *ngIf="project.status === ProjectStatuses.ACTIVE">
                  <a class="dropdown__menu-link" (click)="duplicate(project)">
                    <div class="icon">
                      <svg class="icon__icon-duplicate" width="14px" height="14px">
                        <use xlink:href="#icon-duplicate"></use>
                      </svg>

                    </div>Duplicate</a>
                </li>
                <li class="dropdown__menu-item"
                    *ngIf="project.status === ProjectStatuses.ACTIVE">
                  <a class="dropdown__menu-link" (click)="archive(project.id)">
                    <div class="icon">
                      <svg class="icon__icon-archive" width="14px" height="13px">
                        <use xlink:href="#icon-archive"></use>
                      </svg>

                    </div>Archive</a>
                </li>
                <li class="dropdown__menu-item"
                    *ngIf="project.status === ProjectStatuses.ARCHIVED">
                  <a class="dropdown__menu-link text-red" (click)="delete(project)">
                    <div class="icon">
                      <svg class="icon__icon-trash" width="10px" height="11px">
                        <use xlink:href="#icon-trash"></use>
                      </svg>

                    </div>Delete</a>
                </li>
              </ul>
            </div>
          </div>
        </div>-->
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
